import React from "react";
import ReactDOM from "react-dom";

var LockBodyScroll = function LockBodyScroll() {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "body { overflow: hidden !important; }"), document.head);
};

export default LockBodyScroll;
//# sourceMappingURL=LockBodyScroll.js.map